import { Box, Heading } from 'grommet';
import React from 'react';
import { connect } from 'rxbeach/react';
import { Course } from 'types';
import CourseCard from './CourseCard';
import { courseViewModel$ } from './course$';
import useResponsive from 'hooks/useResponsive';

const Courses = ({ visibleCourses }: { visibleCourses: Course[] }) => {
  const { isMobile } = useResponsive();
  return (
    <Box direction="column">
      <Box align="center" justify="center">
        <Heading level={1}>Våre Kurs</Heading>
        <Heading level={4}>Kom seil med oss da, det blir morro ⛵️</Heading>
      </Box>
      <Box
        direction={isMobile ? 'column' : 'row'}
        align="center"
        justify="center"
        gap="medium"
        pad="medium">
        {visibleCourses.slice(0, 6).map((course) => (
          <CourseCard
            key={course.id}
            {...course}
          />
        ))}
      </Box>
    </Box>
  )
};

export default connect(Courses, courseViewModel$);
